import { create, } from "zustand";
import { type FunctionComponent, } from "react";
import type { ModalizeProps, ModalButtonProps, } from "./types";


export declare type ModalizeStore = {
	Component: FunctionComponent<any> | null;
	closeable: boolean;
	title?: string;
	subtitle?: string;
	props: any;
	classes: string;
	buttons: ModalButtonProps[];
	banner?: boolean;
	blur?: boolean;
	modalize: ( props: ModalizeProps, ) => void;
	dismiss: () => void;
	onBack?: () => void;
	onClose: () => void;
}


export const useModalizeStore = create<ModalizeStore>()((set, get) => ({

	Component: null,
	props: {},
	classes: "",
	title: "",
	buttons: [],
	blur: true,
	closeable: true,
	onClose: () => { },

	modalize: ({
		component,
		props,
		title,
		subtitle,
		classes,
		closeable,
		buttons,
		banner,
		blur,
		onBack,
		onClose,

	}) => {
		set({
			banner,
			blur,
			buttons,
			classes,
			closeable,
			props: props || {},
			subtitle,
			title,
			Component: component,
			onBack,
			onClose,
		});
	},

	dismiss: () => {
		set(initalModalizeState);
	}

}));

const initalModalizeState = {
	Component: null,
	title: "",
	classes: "",
	props: {},
}
